import { render } from "./ConfirmationDialogComponent.vue?vue&type=template&id=7c8312f4&scoped=true&ts=true"
import script from "./ConfirmationDialogComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialogComponent.vue?vue&type=script&lang=ts"

import "./ConfirmationDialogComponent.vue?vue&type=style&index=0&id=7c8312f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8312f4"]])

export default __exports__